// extracted by mini-css-extract-plugin
export default {"tag":"Tag_tag__-oYsz","notSelected":"Tag_notSelected__BcuPb"};